import { useLayoutEffect } from 'react';
import useHoldsStill from '../hooks/useHoldsStill';
import { wear } from '../utils/rootAttribute';

/**
 * MotionAttribute - the root wears `data-motion="reduced"` whenever this screen holds still (useHoldsStill), on EVERY
 * screen: the session, the Workshop, the lobby. Every stylesheet holds still on that attribute and none asks the
 * system's media query (plan body-map C2). A leaf that renders nothing, so a change of motion re-renders only it; a
 * layout effect, so a viewer asking for less never sees a first frame of motion.
 */
export default function MotionAttribute() {
  const still = useHoldsStill();
  useLayoutEffect(() => wear('motion', still ? 'reduced' : null), [still]);
  return null;
}
